import { GESTION_PRODUCTOS_TYPES } from '../constants/gestionProducto.types'
import { gestionProductoInitialState } from '../initital-state/gestionProducto.state'
import { GestionProductoAction, GestionProductoState} from '../interfaces/gestion-Productos.interfaces'




const gestionProductoReducer = (
  state: GestionProductoState = gestionProductoInitialState,
  action: GestionProductoAction
): GestionProductoState => {
  switch (action.type) {
    // *******************************************************************************************************
    // ******************* ACCIONES PARA AGREGAR PRODUCTO ****************************************************
    // *******************************************************************************************************
    case GESTION_PRODUCTOS_TYPES.CP_FORM_HANDLE_CHANGE:
      return {
        ...state,
        agregarProducto: {
          ...state.agregarProducto,
          formProduct: { ...state.agregarProducto.formProduct, ...action.payload },
        },
      }
      
    case GESTION_PRODUCTOS_TYPES.CP_FORM_ADD_ERROR:
      return {
        ...state,
        agregarProducto: {
          ...state.agregarProducto,
          formErrorProduct: { ...state.agregarProducto.formErrorProduct, ...action.payload },
        },
      }
    case GESTION_PRODUCTOS_TYPES.CP_FORM_CHANGE_PAGE:
      return {
        ...state,
        agregarProducto: {
          ...state.agregarProducto,
          paginaActual: state.agregarProducto.paginaActual + action.payload,
        },
      }
    case GESTION_PRODUCTOS_TYPES.CP_SHOW_MODAL_CONFIRMACION:
      return {
        ...state,
        agregarProducto: {
          ...state.agregarProducto,
          modals: { ...state.agregarProducto.modals, activoConfirmacion: action.payload },
        },
      }
    case GESTION_PRODUCTOS_TYPES.CP_SHOW_MODAL_CREADO:
      return {
        ...state,
        agregarProducto: {
          ...state.agregarProducto,
          modals: { ...state.agregarProducto.modals, activoCreado: action.payload },
        },
      }
    case GESTION_PRODUCTOS_TYPES.CP_SET_SUCURSALES:
      return {
        ...state,
        agregarProducto: {
          ...state.agregarProducto,
          catalogos: { ...state.agregarProducto.catalogos, sucursales: action.payload },
        },
      }

      case GESTION_PRODUCTOS_TYPES.CP_FORM_CLEAR_FORM_ONLY:
  return {
    ...state,
    agregarProducto: {
      ...state.agregarProducto,
      formProduct: gestionProductoInitialState.agregarProducto.formProduct,
      formErrorProduct: gestionProductoInitialState.agregarProducto.formErrorProduct,
      // Mantener lo demás intacto: sucursalesAsignadas, paginaActual, modals, etc.
      paginaActual: state.agregarProducto.paginaActual,
      sucursalesAsignadas: state.agregarProducto.sucursalesAsignadas,
      modals: state.agregarProducto.modals,
      datosProductoAgregado: state.agregarProducto.datosProductoAgregado,
      catalogos: state.agregarProducto.catalogos,
    },
  }
  case GESTION_PRODUCTOS_TYPES.CP_SHOW_MODAL_VALIDACIONES:
  return {
    ...state,
    agregarProducto: {
      ...state.agregarProducto,
      modals: {
        ...state.agregarProducto.modals,
        erroresValidaciones: action.payload.errores || [],
      },
    },
  };
    case GESTION_PRODUCTOS_TYPES.CP_SET_SUCURSALES_ASIGNADAS:
      return {
        ...state,
        agregarProducto: { ...state.agregarProducto, sucursalesAsignadas: action.payload },
      }
    case GESTION_PRODUCTOS_TYPES.CP_SET_ID_PRODUCTO_CREADO:
      return {
        ...state,
        agregarProducto: { ...state.agregarProducto, datosProductoAgregado: action.payload },
      }
    case GESTION_PRODUCTOS_TYPES.CP_FORM_CLEAR:
      return gestionProductoInitialState

    // *******************************************************************************************************
    // ******************* ACCIONES PARA LISTAR PRODUCTOS ****************************************************
    // *******************************************************************************************************
    case GESTION_PRODUCTOS_TYPES.LP_SET_ARRAY_PRODUCTOS:
      return { ...state,
        listarProductos: { ...state.listarProductos, arrayProductos: action.payload } }
    case GESTION_PRODUCTOS_TYPES.LP_SET_PRODUCTOS:
      return { ...state, listarProductos: { ...state.listarProductos, productos: action.payload } }
    case GESTION_PRODUCTOS_TYPES.LP_FORM_BUSCAR:
      return {
        ...state,
        listarProductos: { ...state.listarProductos, formBuscar: { ...state.listarProductos.formBuscar, ...action.payload } },
      }
    case GESTION_PRODUCTOS_TYPES.LP_CLEAR_FORM_BUSCAR:
      return { ...state, listarProductos: { ...state.listarProductos, formBuscar: gestionProductoInitialState.listarProductos.formBuscar } }

      
    case GESTION_PRODUCTOS_TYPES.LP_CLEAR:
      return { ...state, listarProductos: gestionProductoInitialState.listarProductos }
    case GESTION_PRODUCTOS_TYPES.LP_SHOW_MODAL_ELIMINAR_PRODUCTO:
      return {
        ...state,
        listarProductos: {
          ...state.listarProductos,
          modales: { ...state.listarProductos.modales, activeEliminar: action.payload },
        },
      }
    case GESTION_PRODUCTOS_TYPES.LP_SHOW_MODAL_ESTATUS:
      return {
        ...state,
        listarProductos: {
          ...state.listarProductos,
          modales: { ...state.listarProductos.modales, activeEstatus: action.payload },
        },
      }

    case GESTION_PRODUCTOS_TYPES.LP_SET_SUCURSALES:
      return {
        ...state,
        listarProductos: {
          ...state.listarProductos,
          catalogos: {
            ...state.listarProductos.catalogos,
            sucursales: action.payload,
          },
        },
      }
    case GESTION_PRODUCTOS_TYPES.LP_SET_SUCURSALES_ASIGNADAS:
      return {
        ...state,
        listarProductos: {...state.listarProductos, sucursalesAsignadas: action.payload},
      }

    case GESTION_PRODUCTOS_TYPES.LP_SET_PRODUCTO_SELECCIONADO:
      return {
        ...state,
        listarProductos: {
          ...state.listarProductos,
          productoSeleccionado: action.payload,
        }
      }


      case GESTION_PRODUCTOS_TYPES.LP_SHOW_MODAL_SUCURSALES:
        return {
          ...state,
          listarProductos: {
            ...state.listarProductos,
            modales: { 
              ...state.listarProductos.modales, 
              activeSucursales: action.payload
            },
          },
        }


    // *******************************************************************************************************
    // ******************* ACCIONES PARA EDITAR PRODUCTO *****************************************************
    // *******************************************************************************************************
    /* case GESTION_PRODUCTOS_TYPES.EP_SET_SUCURSALES:
  return {
    ...state,
    editarProducto: {
      ...state.editarProducto,
      formProduct: { ...state.editarProducto.formProduct, ...action.payload },
    },
  }; */
  case GESTION_PRODUCTOS_TYPES.EP_FORM_CLEAR_FORM_ONLY:
  return {
    ...state,
    editarProducto: {
      ...state.editarProducto,
      formProduct: gestionProductoInitialState.editarProducto.formProduct,
      formErrorProduct: gestionProductoInitialState.editarProducto.formErrorProduct,
      // Mantener sucursalesAsignadas y modales
      sucursalesAsignadas: state.editarProducto.sucursalesAsignadas,
      modales: state.editarProducto.modales,
      productoSeleccionado: state.editarProducto.productoSeleccionado,
    },
  };

  case GESTION_PRODUCTOS_TYPES.EP_SET_SUCURSALES:
  return {
    ...state,
    editarProducto: {
      ...state.editarProducto,
      catalogos: {
        ...state.editarProducto.catalogos,
        sucursales: action.payload,
      },
    },
  };
  case GESTION_PRODUCTOS_TYPES.EP_SET_SUCURSALES_ASIGNADAS:
  return {
    ...state,
    editarProducto: { ...state.editarProducto, sucursalesAsignadas: action.payload },
  }



    case GESTION_PRODUCTOS_TYPES.EP_FORM_EDITAR_HANDLE_CHANGE:
      return {
        ...state,
        editarProducto: {
        ...state.editarProducto,
        formProduct: { ...state.editarProducto.formProduct, ...action.payload },
      },
    }
    case GESTION_PRODUCTOS_TYPES.EP_FORM_EDITAR_ADD_ERROR:
      return {
        ...state,
        editarProducto: {
          ...state.editarProducto,
          formErrorProduct: { ...state.editarProducto.formErrorProduct, ...action.payload},
        },
      }
    case GESTION_PRODUCTOS_TYPES.EP_SHOW_MODAL_ELIMINAR_PRODUCTO:
      return {
        ...state,
        editarProducto: {
          ...state.editarProducto,
          modales: {
            ...state.editarProducto.modales, activeEliminar: action.payload},
          },
        }
    case GESTION_PRODUCTOS_TYPES.EP_SET_PRODUCTO_SELECCIONADO:
  return {
    ...state,
    editarProducto: {
      ...state.editarProducto,
      productoSeleccionado: action.payload,
      formProduct: {
        ...state.editarProducto.formProduct,
        sucursalesAsignadas: action.payload.sucursalesAsignadas || [],
      },
    },
  }

    case GESTION_PRODUCTOS_TYPES.EP_CLEAR:
      return { ...state, editarProducto: gestionProductoInitialState.editarProducto }
    

      

    // *******************************************************************************************************
    // ******************* ACCIONES PARA CATEGORÍAS Y SUCURSALES ********************************************
    // *******************************************************************************************************
    
    case GESTION_PRODUCTOS_TYPES.CS_SET_CATEGORIAS_LIST:
      return { ...state, sucursales: { ...state.sucursales, dataSucursales: action.payload } }
    case GESTION_PRODUCTOS_TYPES.CS_SET_SUCURSALES_LIST:
      return { ...state, sucursales: { ...state.sucursales, dataSucursales: action.payload } }
    case GESTION_PRODUCTOS_TYPES.CS_SET_FORM_PRODUCTO:
      return { ...state, agregarProducto: { ...state.agregarProducto, formProduct: { ...state.agregarProducto.formProduct, ...action.payload } } }
    case GESTION_PRODUCTOS_TYPES.CS_SET_ERRORS_FORM_PRODUCTO:
      return { ...state, agregarProducto: { ...state.agregarProducto, formErrorProduct: { ...state.agregarProducto.formErrorProduct, ...action.payload } } }
    case GESTION_PRODUCTOS_TYPES.CS_CLEAR_FORM_PRODUCTO:
      return {
        ...state,
        agregarProducto: {
          ...state.agregarProducto,
          formProduct: gestionProductoInitialState.agregarProducto.formProduct,
          formErrorProduct: gestionProductoInitialState.agregarProducto.formErrorProduct,
        },
      }

    default:
      return state
  }
}

export default gestionProductoReducer
